import {useEffect, useState, FC} from 'react';
import Checkbox from '@/shared/components/Checkbox';
import ActionsMenu from '@/shared/components/Table/ActionMenu';
import {Box, FormControlLabel, FormGroup} from '@mui/material';
import {teamSectionStyle} from '../../Profile/Team/Team.styles';
import {modalStyle} from '@/shared/components/Modal/Modal.styles';
import Button from '@/shared/components/Button';
import {OUTLINE} from '@/utils/constants';
import {filtersModalStyles} from './filtersModalStyles';
import { useAppSelector } from '@/store/hooks';
import { getReportColumnsSelector } from '@/store/organization-report/selectors';

interface FilterModalProps {
	selectedColumns: Record<string, boolean>;
	onConfirm: (columns: Record<string, boolean>) => void;
	onClose: () => void;
}

const FiltersModal: FC<FilterModalProps> = ({selectedColumns, onConfirm, onClose}) => {
		const columns = useAppSelector(getReportColumnsSelector);

		const columnOptions = columns.map((col) => col.label)



	const [tempSelectedColumns, setTempSelectedColumns] = useState<Record<string, boolean>>(selectedColumns);

	useEffect(() => {
		setTempSelectedColumns({...selectedColumns});
	}, [selectedColumns]);

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setTempSelectedColumns((prev) => ({
			...prev,
			[event.target.name]: event.target.checked,
		}));
	};

	const handleConfirm = () => {
		onConfirm(tempSelectedColumns);
		onClose();
	};

	const middleIndex = Math.ceil(columnOptions.length / 2);
	const leftColumns = columnOptions.slice(0, middleIndex);
	const rightColumns = columnOptions.slice(middleIndex);

	return (
		<>
			<Box sx={filtersModalStyles.modalContainer}>
				<Box sx={filtersModalStyles.columnsWrapper}>
					<Box sx={filtersModalStyles.leftColumn}>
						<FormGroup>
							{leftColumns.map((col) => (
								<Box key={col} sx={filtersModalStyles.columnItem}>
									<FormControlLabel
										control={<Checkbox checked={!!tempSelectedColumns[col]} onChange={handleChange} name={col} />}
										label={col}
										sx={filtersModalStyles.checkboxLabel}
										value={!!tempSelectedColumns[col]}
									/>
									{/* <ActionsMenu isSixDots content={<Box sx={teamSectionStyle.menuContent}>{col}</Box>} /> */}
								</Box>
							))}
						</FormGroup>
					</Box>
					<Box sx={filtersModalStyles.rightColumn}>
						<FormGroup>
							{rightColumns.map((col) => (
								<Box key={col} sx={filtersModalStyles.columnItemRight}>
									<FormControlLabel
										control={<Checkbox checked={!!tempSelectedColumns[col]} onChange={handleChange} name={col} />}
										label={col}
										sx={filtersModalStyles.checkboxLabelRight}
										value={!!tempSelectedColumns[col]}
									/>
									{/* <ActionsMenu isSixDots content={<Box sx={teamSectionStyle.menuContent}>{col}</Box>} /> */}
								</Box>
							))}
						</FormGroup>
					</Box>
				</Box>
			</Box>
			<Box sx={filtersModalStyles.actionsContainer}>
				<Box sx={modalStyle.actions}>
					<Button title="Cancel" variant={OUTLINE} sx={modalStyle.buttonClose} onClick={onClose} disableRipple />
					<Button title="Confirm" sx={modalStyle.buttonSave} onClick={handleConfirm} />
				</Box>
			</Box>
		</>
	);
};

export default FiltersModal;
